module.exports = __webpack_public_path__ + "67d30e1caff47ecfdf9367b5f0a2e09e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CG.svg
// module id = zKu7
// module chunks = 0